import React from 'react';
import { approachSteps, profile } from '../data/profile';
import { AnimatedBackdrop } from './AnimatedBackdrop';
import { Reveal } from './Reveal';
export function ApproachSteps() {
  return <section id="approach" aria-label="Leadership approach" className="relative w-full overflow-hidden bg-navy py-20 lg:py-24" data-id="element-51" data-mp="1uukhrjv6qd01">
      <AnimatedBackdrop data-id="element-52" data-mp="1yttbwpu50cw4" />
      <div className="relative mx-auto max-w-shell px-6 sm:px-8" data-id="element-53" data-mp="1kvuxxljqaih5">
        <Reveal data-id="element-54" data-mp="1kua643ostdmz">
          <div className="flex items-center gap-3" data-id="element-55" data-mp="1kxxukofdz9uu">
            <span className="h-px w-8 bg-metal" aria-hidden="true" data-id="element-56" data-mp="1pvzf7dsgnh8f" />
            <span className="text-[11px] font-semibold uppercase tracking-label text-metal-light" data-id="element-57" data-mp="1bvg9idbgwn9f">
              How I Work
            </span>
          </div>
          <h2 className="mt-6 max-w-2xl font-serif text-[30px] font-semibold leading-[1.15] tracking-[-0.015em] text-white sm:text-4xl" data-id="element-58" data-mp="1fx1vco5zcbvr">
            A method that makes results repeatable
          </h2>
        </Reveal>

        <ol className="mt-14 grid grid-cols-1 gap-10 md:grid-cols-3" data-id="element-59" data-mp="3a8gmn9en2jdm">
          {approachSteps.map((step, index) => <Reveal key={step.step} delay={index * 0.08} as="li" data-id="element-60" data-mp="2ehpj17x5alkp" data-mpi={index}>
              <div className="border-t-2 border-metal pt-6" data-id="element-61" data-mp="2efd65968v1ei">
                <span className="font-serif text-[13px] font-semibold tracking-[0.1em] text-metal-light" data-id="element-62" data-mp="2t5anp69o4suq">
                  {step.step}
                </span>
                <h3 className="mt-4 font-serif text-[23px] font-semibold leading-tight text-white" data-id="element-63" data-mp="20hola1c6fu9g">
                  {step.title}
                </h3>
                <p className="mt-3.5 text-[15px] leading-[1.7] text-white/60" data-id="element-64" data-mp="1vjvcd0jhom5h">{step.description}</p>
              </div>
            </Reveal>)}
        </ol>

        <Reveal delay={0.1} data-id="element-65" data-mp="25g88s66f5e3x">
          <p className="mt-14 max-w-3xl border-l-2 border-white/20 pl-6 font-serif text-[20px] leading-[1.5] text-white/80 lg:text-[23px]" data-id="element-66" data-mp="25fyhmf9n10wn">
            {profile.valueStatement}
          </p>
        </Reveal>
      </div>
    </section>;
}